// Libraries
import React from 'react';
import PropTypes from 'prop-types';

const CustomTooltipAttribute = ({ tooltipLabel, tooltipValue, percentage }) => (
  <div className="custom-tooltip__label" key={tooltipLabel}>
    {tooltipLabel}
    <span className="custom-tooltip__value">{` ${tooltipValue}${percentage ? '%' : ''}`}</span>
  </div>
);

CustomTooltipAttribute.defaultProps = {
  tooltipValue: 0,
  percentage: false,
};

CustomTooltipAttribute.propTypes = {
  tooltipLabel: PropTypes.string.isRequired,
  percentage: PropTypes.bool,
  tooltipValue: PropTypes.string,
};

export default CustomTooltipAttribute;
